var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "star",
    transform: "translate(13664.333 2733.333)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_257",
    "data-name": "Ellipse 257",
    cx: 10,
    cy: 10,
    r: 10,
    transform: "translate(-13664.333 -2733.333)",
    fill: "#dc3a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8974",
    "data-name": "Path 8974",
    d: "M40.436,35.985a.651.651,0,0,0-.364-1.106l-2.546-.364a.65.65,0,0,1-.485-.348l-1.136-2.3a.638.638,0,0,0-1.152,0l-1.136,2.3a.615.615,0,0,1-.485.348l-2.546.364a.651.651,0,0,0-.364,1.106l1.833,1.8a.628.628,0,0,1,.182.576l-.439,2.53a.662.662,0,0,0,.955.682l2.273-1.2a.617.617,0,0,1,.606,0l2.273,1.2a.649.649,0,0,0,.939-.682l-.439-2.53a.67.67,0,0,1,.182-.576Z",
    transform: "translate(-13689.662 -2759.909)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.0f4cd684c8908b4a0a13af002fc2aaaa.svg";
export { ForwardRef as ReactComponent };